module.exports = __webpack_public_path__ + "img/product-preview-31.9da9113.png";